import { useState, useRef } from "react";
import toast, { Toaster } from "react-hot-toast";
import ReCAPTCHA from "react-google-recaptcha";

const CaseStudyDownloadForm = ({ fileLink }) => {
  const recaptcha = useRef();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    jobTitle: "",
    company: "",
  });
  const [downloading, setDownloading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name || !formData.email || !formData.phone || !formData.company) {
      toast.error("Please fill all required fields.");
      return;
    }

    const token = await recaptcha.current.executeAsync();
    recaptcha.current.reset();

    if (!token) {
      toast.error("Please verify captcha.");
      return;
    }

    setDownloading(true);

    const form = e.target;
    const formDataWithToken = new FormData(form);
    formDataWithToken.append("g-recaptcha-response", token);

    try {
      const response = await fetch(form.action, {
        method: "POST",
        body: formDataWithToken,
      });

      if (response.ok) {
        toast.success("Form submitted! Starting download...");

        setTimeout(() => {
          if (fileLink) {
            const link = document.createElement("a");
            link.href = fileLink;
            link.download = "case-study.pdf"; // optional
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }

          toast.success("Download started!");
          setDownloading(false);
        }, 2000);
      } else {
        throw new Error("Failed to send email.");
      }
    } catch (error) {
      toast.error("Error submitting form. Try again.");
      setDownloading(false);
    }
  };

  return (
    <div className="mx-auto">
      <Toaster position="top-center" reverseOrder={false} />
      <form
        action="https://formsubmit.co/fardeen-intekhaab@mean3.com"
        method="POST"
        onSubmit={handleSubmit}
        className="space-y-4"
      >
        <input type="hidden" name="_captcha" value="false" />

        <input
          type="text"
          name="name"
          placeholder="Your name*"
          required
          value={formData.name}
          onChange={handleChange}
          className="w-full p-3 border border-gray-300 rounded-sm"
        />
        <input
          type="email"
          name="email"
          placeholder="Email address*"
          required
          value={formData.email}
          onChange={handleChange}
          className="w-full p-3 border border-gray-300 rounded-sm"
        />
        <input
          type="tel"
          name="phone"
          placeholder="Phone Number*"
          required
          value={formData.phone}
          onChange={handleChange}
          className="w-full p-3 border border-gray-300 rounded-sm"
        />
        <input
          type="text"
          name="jobTitle"
          placeholder="Job Title"
          value={formData.jobTitle}
          onChange={handleChange}
          className="w-full p-3 border border-gray-300 rounded-sm"
        />
        <input
          type="text"
          name="company"
          placeholder="Company name*"
          required
          value={formData.company}
          onChange={handleChange}
          className="w-full p-3 border border-gray-300 rounded-sm"
        />

        {/* Captcha */}
        {/* <ReCAPTCHA
          ref={recaptcha}
          sitekey={process.env.REACT_APP_SITE_KEY}
        /> */}

        <button
          type="submit"
          className="w-full bg-red-600 text-white p-2 rounded-sm font-semibold hover:bg-red-800"
          disabled={downloading}
        >
          {downloading ? "Downloading..." : "Download"}
        </button>
      </form>
    </div>
  );
};

export default CaseStudyDownloadForm;
